import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const MaximizeIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="24"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M4 8v-2a2 2 0 0 1 2 -2h2"></path>
        <path d="M4 16v2a2 2 0 0 0 2 2h2"></path>
        <path d="M16 4h2a2 2 0 0 1 2 2v2"></path>
        <path d="M16 20h2a2 2 0 0 0 2 -2v-2"></path>
      </svg>
    </SvgIcon>
  );
};
